module.exports = __webpack_public_path__ + "media/src/images/balloons/banner_weekendsale-d4678c232bf5c929ed626ae4a92a5fe3.png";